import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router";
import Main from "./Main";
import MainJp from "../src/page/MainJp"
import PhotoGallery from "./page/PhotoGallery";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/jp" element={<MainJp />} />
        <Route path="/gallery" element={<PhotoGallery />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
